export default "__VITE_ASSET__DwmfQHfv__"